import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0359c04e")

_pushScopeId("data-v-0359c04e")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "set-mode-tip" }, "将选中车辆控车设备 管控设定为：", -1)
const _hoisted_2 = { class: "set-mode-radio" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("自动：根据严格控车模式管控")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("手动：不会参与严格控车模式")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("暂停：不会参与严格控车模式，企业也不可编辑与删除")
const _hoisted_6 = { class: "dialog-footer" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("确 定")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_radio = _resolveComponent("el-radio")
  const _component_el_radio_group = _resolveComponent("el-radio-group")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: "设定管控",
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.visible = $event)),
    "close-on-click-modal": false,
    width: "500px",
    onClose: _ctx.handleCloseDialog
  }, {
    footer: _withId(() => [
      _createVNode("span", _hoisted_6, [
        _createVNode(_component_el_button, { onClick: _ctx.handleCloseDialog }, {
          default: _withId(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.submitDialog
        }, {
          default: _withId(() => [
            _hoisted_8
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withId(() => [
      _hoisted_1,
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_el_radio_group, {
          modelValue: _ctx.controlMode,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.controlMode = $event))
        }, {
          default: _withId(() => [
            _createVNode(_component_el_radio, {
              label: _ctx.controlModeEnum.自动
            }, {
              default: _withId(() => [
                _hoisted_3
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_radio, {
              label: _ctx.controlModeEnum.手动
            }, {
              default: _withId(() => [
                _hoisted_4
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_radio, {
              label: _ctx.controlModeEnum.暂停
            }, {
              default: _withId(() => [
                _hoisted_5
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "onClose"]))
})